import React, { memo } from 'react';
import { VStack } from 'native-base';
import { Functions, Typography } from 'fmc-digital-common';
import { NTBBanner } from '../../atoms';
const NTBCashOutBannerWithOutSavings = /*#__PURE__*/memo(props => {
  return /*#__PURE__*/React.createElement(NTBBanner, null, /*#__PURE__*/React.createElement(VStack, {
    alignItems: 'center',
    justifyContent: 'center',
    width: '68',
    minHeight: {
      lg: '27.5',
      sm: '20',
      base: '20'
    },
    accessibilityLabel: "cashout banner without savings",
    accessibilityRole: "text",
    "data-testid": "cashoutbanner-withoutsavings"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption13",
    fontWeight: 700,
    color: "darkGray.900"
  }, "ESTIMATED CASH OUT"), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "success.300",
    accessibilityRole: "text",
    "data-testid": "estimated-cashout-withoutsavings"
  }, Functions.toUSD(props?.originationLoan?.estimatedCashOut))));
});
export default NTBCashOutBannerWithOutSavings;
//# sourceMappingURL=NTBCOBannerWithoutSavings.js.map